// this function will sort elements (param) by their name alphabetically and ignore the word "The" at the beginning of the name. It will also ignore case sensitivity.
export const sortElementsNoThe = (elements) => {
    return elements.sort((a, b) => {
        const nameA = a.name.toUpperCase().replace(/^THE\s/, '');
        const nameB = b.name.toUpperCase().replace(/^THE\s/, '');
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });
}